import { useTranslation } from 'next-i18next';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import {
  LandingPageIds,
  WebflowLandingPages,
  landingPageExists,
} from '@bridebook/web/lib/landing/webflow-page-urls';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { getArticlesSupport } from '../article/selectors';
import { useSelector } from '../utils';

interface TopBarLink {
  name: string;
  nameShort: string;
  url: string;
}

export const useTopBarLinks = (): TopBarLink[] => {
  const { t } = useTranslation('common');
  const market = useMarket();
  const articlesSupport = useSelector(getArticlesSupport);

  return [
    {
      name: t('topBarLinks.venues'),
      nameShort: t('topBarLinksShort.venues'),
      url: '/search/wedding-venues',
    },
    landingPageExists(LandingPageIds.weddingSuppliers, market) && {
      name: t('topBarLinks.suppliers'),
      nameShort: t('topBarLinksShort.suppliers'),
      url: WebflowLandingPages[LandingPageIds.weddingSuppliers].bridebookPath,
    },
    landingPageExists(LandingPageIds.weddingWebsite, market) && {
      name: t('topBarLinks.websites'),
      nameShort: t('topBarLinksShort.websites'),
      url: WebflowLandingPages[LandingPageIds.weddingWebsite].bridebookPath,
    },
    landingPageExists(LandingPageIds.weddingPlanningTools, market) && {
      name: t('topBarLinks.planning'),
      nameShort: t('topBarLinksShort.planning'),
      url: WebflowLandingPages[LandingPageIds.weddingPlanningTools].bridebookPath,
    },
    landingPageExists(LandingPageIds.weddingIdeasInspiration, market) && {
      name: t('topBarLinks.ideas'),
      nameShort: t('topBarLinksShort.ideas'),
      url: WebflowLandingPages[LandingPageIds.weddingIdeasInspiration].bridebookPath,
    },
    articlesSupport && {
      name: t('topBarLinks.advice'),
      nameShort: t('topBarLinksShort.advice'),
      url: UrlHelper.advice,
    },
  ].filter((link): link is TopBarLink => Boolean(link));
};
